// src/localization/lang.de.js

export const german = {
  header: {
    logoAlt: "Fast Caution Logo",
    home: "Startseite",
    create: "Kaution erstellen",
    pricing: "Preise",
    contact: "Kontakt",
    language: "Sprache",
  },
  footer: "Alle Rechte vorbehalten.",
  home: {
    title: "<0>Fast</0> Caution",
    subtitle: "Die einfache und sichere Lösung für Ihre kurzfristigen Mietkautionen*, per Kreditkarte.",
    ctaPrimary: "🚀 Erstellen Sie Ihre Kaution in 1 Minute",
    cardTitle: "Wie funktioniert's?",
    step1: "Erstellen Sie eine Kautionsanfrage und senden Sie diese an die Person Ihrer Wahl, <0>es ist kostenlos</0>!",
    step2: "Die Person zahlt ihre Kaution per Kreditkarte, ohne dass diese belastet wird.",
    step3: "Ein Schaden? Ziehen Sie die Kaution teilweise oder vollständig ein**.",
    cardFooter: "Einfach, Grundlegend",
    ctaSecondary: "🚀 Meine Kaution in 1 Minute erstellen",
    disclaimer: "* Maximal 7 Tage.\n** Wenn Sie die Kaution freigeben, fallen keine Gebühren an, es ist kostenlos! Wenn Sie jedoch die Kaution (vollständig oder teilweise) einziehen, fallen Banktransaktionsgebühren an (5% + 3€ fest)."
  },
  contact: {
    title: "Kontaktformular",
    subtitle: "Ein Problem, Zweifel oder benötigen Sie Informationen?",
    cardTitle: "Kontaktieren Sie uns",
    emailLabel: "Ihre E-Mail-Adresse",
    subjectLabel: "Betreff",
    messageLabel: "Nachricht",
    submitButton: "Senden",
    loading: "Wird gesendet...",
    errorEmpty: "Bitte füllen Sie alle Felder aus.",
    errorInvalidEmail: "Ungültige E-Mail-Adresse.",
    success: "Ihre Nachricht wurde erfolgreich gesendet. Wir antworten Ihnen schnellstmöglich."
  },
  pricing: {
    title: "Unsere Preise",
    subtitle: "Klare und transparente Preise.",
    cardTitle: "",
    creationLabel: "Erstellen einer Kaution",
    creationValue: "KOSTENLOS",
    releaseLabel: "Freigabe der Kaution",
    releaseValue: "KOSTENLOS",
    collectionLabel: "Einzug der Kaution",
    collectionValue: "5% des eingezogenen Betrags + 3€",
    footerText: "Einfach, Grundlegend 😍",
    cta: "🚀 Meine Kaution erstellen"
  },
  checkout: {
    topImageAlt: "Fast Caution Logo",
    title: "",
    subtitle: "Die einfache und sichere Lösung für Ihre kurzfristigen Mietkautionen*, per Kreditkarte.",
    cardTitle: "Kaution",
    referenceLabel: "Referenz:",
    requestedByLabel: "Angefordert von",
    cta: "Kaution bestätigen",
    loading: "Laden...",
    disclaimerStar: "* Maximal 7 Tage",
    disclaimerText:
      "KEINE Abbuchung von Ihrem Bankkonto (außer bei Prepaid-Karten und Neo-Banken wie Revolut, N26 usw.).\nEs handelt sich lediglich um eine Reservierung des angegebenen Betrags, vergleichbar mit der Anmietung eines Fahrzeugs.\nLediglich Ihr Kreditkartenlimit wird beeinträchtigt."
  },
  checkoutSuccess: {
    title: "Kaution bestätigt!",
    description: "Ihre Vorautorisierung wurde erfolgreich bestätigt.",
    homeButton: "Zurück zur Startseite"
  },
  createDepositSuccess: {
    title: "Ihre Kautionsanfrage wurde erfolgreich versandt 🚀",
    cardTitle: "Meine Informationen aktualisieren",
    referenceLabel: "Referenz:",
    prompt: "⚠️ Teilen Sie dem Empfänger mit, wer Sie sind",
    firstNameLabel: "Mein Vorname",
    lastNameLabel: "Mein Nachname",
    updateButton: "Informationen aktualisieren",
    success: "Erfolgreich aktualisiert!",
    errorPrefix: "Fehler:",
    loading: "Laden..."
  },
  createDeposit: {
    title: "Ihre Kautionsanfrage erstellen",
    subtitle: "Der Empfänger erhält den Zahlungslink per E-Mail. Nach Zahlung werden auch Sie per E-Mail benachrichtigt.",
    cardOwnerTitle: "Sie (oder Eigentümer)",
    cardOwnerSubtitle: "Die Person, die die Kaution anfordert",
    cardClientTitle: "Empfänger (oder Kunde)",
    cardClientSubtitle: "Die Person, die Ihre Kaution zahlen wird",
    ownerEmailLabel: "Ihre E-Mail-Adresse",
    depositAmountLabel: "Gewünschter Kautionsbetrag",
    ownerClientEmailLabel: "E-Mail-Adresse des Empfängers",
    errorTextfieldDeposit: "Der Betrag muss zwischen 20 und 2000 liegen",
    submitButton: "Anfrage senden",
    errorPrefix: "Fehler:",
    errorEmptyFields: "Alle Felder müssen ausgefüllt sein.",
    errorInvalidEmail: "Die E-Mail-Adressen müssen gültig sein.",
    errorSameEmail: "Die E-Mail-Adresse des Empfängers darf nicht mit Ihrer identisch sein.",
    errorResponse: "Fehler: Ungültige Antwort.",
    captchaNotLoaded: "reCAPTCHA Enterprise ist nicht geladen.",
    loading: "Verarbeitung..."
  },
  collectDeposit: {
    title: "Kaution einziehen",
    description: "Bitte geben Sie die Informationen ein, um die Kaution einzuziehen.",
    labelField: "Einzuziehender Betrag",
    submitButton: "Einziehen",
    loading: "Einziehen läuft...",
    error: "Ein Fehler ist aufgetreten.",
    success: "Die Kaution wurde erfolgreich eingezogen.",
    verificationTitle: "Verifizierung erforderlich",
    verificationSubtitle: "Um die Kaution einzuziehen, müssen Sie zuerst Ihre Identität bestätigen.",
    verificationButton: "Meine Identität bestätigen",
    pageErrorTitle: "Fehler",
    pageErrorSubtitle: "Die erforderlichen Parameter wurden nicht in der URL übergeben",
  },
  releaseDeposit: {
    title: "Kaution freigeben",
    description: "Bestätigen Sie, dass Sie die Kaution freigeben möchten.",
    submitButton: "Freigeben",
    loading: "Freigabe läuft...",
    success: "Die Kaution wurde erfolgreich freigegeben.",
    error: "Bei der Freigabe der Kaution ist ein Fehler aufgetreten.",
    pageErrorTitle: "Fehler",
    pageErrorSubtitle: "Die erforderlichen Parameter wurden nicht in der URL übergeben",
  },
  notFound: {
    title: "Seite nicht gefunden",
    description: "Entschuldigung, die gesuchte Seite existiert nicht.",
    homeButton: "Zurück zur Startseite"
  }
};
